<div class="ap-mb-spacing-4">
  <gstar-combobox
    [label]="'upsertSecurity.answer' | translate"
    [options]="options"
    keyProp="label"
    valueProp="value"
    [value]="selected"
    ngDefaultControl
    [disabled]="true"
    [width]="200" />
</div>
